import PagePaymentAtAnotherWaterMachine from "./PagePaymentAtAnotherWaterMachine";

export default PagePaymentAtAnotherWaterMachine;
